// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".float-button-right[data-v-7d3ce44b] {\n  float: right;\n  right: 30px;\n  position: absolute;\n  z-index: 15;\n}", ""]);
// Exports
module.exports = exports;
